import React, { useState } from 'react'
import './qr-code-scanner-v2.styles.scss';
import { Scanner } from '@yudiel/react-qr-scanner';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCameraRotate } from '@fortawesome/free-solid-svg-icons';

const QRCodeScannerV2 = ({
    onScanSuccess,
    onScanError
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [ data, setData ] = useState('No result');
  const [ cameraMode, setCameraMode ] = useState('environment'); 
  // 'user' for front camera, 'environment' for back camera
  const navigate = useNavigate();

  function switchMode() {
      // This function can be used to switch between camera modes if needed
      setCameraMode(prevMode => (
          prevMode === 'user' 
          ? 'environment' 
          : 'user'
      ));
  }

  return (
    <div className='qr-code-scanner-v2'>
      <div>Scan a player's QR Code to easily distribute rewards!</div>
      <div className="g-space-1"></div>
      <Scanner 
        onScan={(result) => onScanSuccess(result[0].rawValue)}
        constraints={cameraMode}
        allowMultiple={false} />
      <div className="g-space-1"></div>
      <button onClick={switchMode} className="g-button">
          <FontAwesomeIcon icon={faCameraRotate} />
          Switch Camera
      </button>
    </div>
  )
}

export default QRCodeScannerV2